import { BASE_WEIGHTS_KG } from "@biosany/shared"
import { catalogPriceId, imageBaseURL } from "@/lib/utils"
import type { ProductImage } from "./products"
import type { SERVICE_SLUGS } from "./slugs"

export type ServiceId = "consulta" | "dieta"
export type ServiceSlug = (typeof SERVICE_SLUGS)[number]

export interface ServiceProps {
	id: ServiceId
	name: string
	title: string
	description: string
	set: string
	price: number
	priceId: string
	weight: number
	image: ProductImage
}

const SERVICES: Record<ServiceId, ServiceProps> = {
	consulta: {
		id: "consulta",
		name: "Consulta remota",
		title: "Incluir consulta remota",
		description: "Llamada directa de 20 minutos.",
		set: "Video llamada",
		price: 300,
		priceId: catalogPriceId("consulta"),
		weight: BASE_WEIGHTS_KG["consulta"]!,
		image: { source: imageBaseURL("services/gallery/consulta.webp"), width: 270, height: 200, alt: "Consulta remota" }
	},
	dieta: {
		id: "dieta",
		name: "Dieta personalizada",
		title: "Incluir dieta personalizada",
		description: "Plan nutricional personalizado de 4 semanas para combatir tu padecimiento.",
		set: "Via email o whatsapp",
		price: 300,
		priceId: catalogPriceId("dieta"),
		weight: BASE_WEIGHTS_KG["dieta"]!,
		image: { source: imageBaseURL("services/gallery/dieta.webp"), width: 270, height: 200, alt: "Dieta personalizada" }
	}
}

export const getServiceById = (id: ServiceId): ServiceProps => SERVICES[id]
export const getPriceByServiceId = (id: ServiceId): number => SERVICES[id].price

/** Slug de URL (`/servicios/:slug`) → `ServiceId` interno usado en carrito/admin/envíos. */
const SLUG_TO_SERVICE_ID: Record<ServiceSlug, ServiceId> = {
	"dieta-personalizada": "dieta",
	"consulta-remota": "consulta"
}

export const getServiceIdBySlug = (slug: string): ServiceId | undefined => SLUG_TO_SERVICE_ID[slug as ServiceSlug]

export default SERVICES
